module.exports = __webpack_public_path__ + "img/logo.0ae640a8.svg";